import {EventEmitter, Injectable} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FuseSplashScreenService} from '@barebone-fuse/@fuse/services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {take} from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class PlatformToolValueMappingHandler implements IPlatformToolHandler {
  magicLinkModel: MagicLinkModel;
  invalidateSubject = new InvalidateSubject();
  magicLinkModelValueChanged = new EventEmitter<any>();
  activatedRoute?: ActivatedRoute;
  metaData?: any;
  selectedTabModel: TabModel;

  constructor(private router: Router,
              private commandService: CommandService,
              private snackBarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService) {
  }

  executeCommand(command: PlatformCommand) {
    if (command.fieldValues['DialogDefinition']) {
      delete command.fieldValues['DialogDefinition'];
    }
    if (command.fieldValues['RedirectUrl']) {
      this.router.navigateByUrl(command.fieldValues['RedirectUrl']);
      return;
    }
    this.executeCommandToApi(command);
  }

  valueChanged(event: any) {
    if (event.action) {
      if (this.magicLinkModel.additionalCommands[`${event.fieldDefinition.key}ActionCommand`]) {
        const command = this.magicLinkModel.additionalCommands[`${event.fieldDefinition.key}ActionCommand`];
        command.fieldValues['ItemId'] = event.item.id;
        command.fieldValues['FieldKey'] = event.fieldDefinition.key;
        this.executeCommand(command);
      } else if (this.magicLinkModel.additionalCommands[`${event.action.id}ActionCommand`]) {
        const command = this.magicLinkModel.additionalCommands[`${event.action.id}ActionCommand`];
        command.fieldValues['ItemId'] = event.item.id;
        if (event.action.id === 'MoveOrder') {
          command.fieldValues['Operation'] = event.action.op;
        }
        this.executeCommand(command);
      }
      return;
    }
    if (this.magicLinkModel.additionalCommands[`${event.fieldDefinition.key}LinkCommand`]) {
      const command = this.magicLinkModel.additionalCommands[`${event.fieldDefinition.key}LinkCommand`];
      command.fieldValues['ItemId'] = event.item.id;
      command.fieldValues['FieldKey'] = event.fieldDefinition.key;
      this.executeCommand(command);
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
  }

  destroy(): void {
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
            return;
          }
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
            return;
          }
          this.invalidateSubject.invalidate();

        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
      this.fuseSplashScreenService.hide();
    }
  }
}
